import React, { useContext } from 'react';
import styled, { css } from 'styled-components';
import { Avatar } from '@ubeya/shared-web/components/Avatar';
import { ReactComponent as NoAssigneeIcon } from '@ubeya/shared-web/assets/help-desk/no-assignee.svg';
import Tooltip from '@ubeya/shared-web/components/Tooltip/Tooltip';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';

const Wrapper = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-width: 0;

  ${({ $disabled, theme }) =>
    $disabled &&
    css`
      color: ${theme.colors.grey4};
      cursor: default;
    `}
`;

const NoAssigneeWrap = styled.span`
  display: inline-flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.grey4};

  svg {
    width: 20px;
    height: 20px;
  }
`;

const AvatarWrap = styled.span`
  display: inline-flex;
  flex-shrink: 0;
`;

const AssigneeName = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;

  ${({ $truncate }) =>
    $truncate &&
    css`
      max-width: 140px;
    `}
  line-height: 20px;
  font-size: 12px;
`;

const AssigneeDisplay = ({
  admin,
  compact = false,
  disabled = false,
  hideNoAssigneeIcon = false,
  truncate = false
}) => {
  const { t } = useContext(ConfigContext);

  if (!admin) {
    return hideNoAssigneeIcon ? null : (
      <Tooltip body={t('help_desk_no_assignee')}>
        <Wrapper $disabled={disabled}>
          <NoAssigneeWrap>
            <NoAssigneeIcon />
          </NoAssigneeWrap>
        </Wrapper>
      </Tooltip>
    );
  }

  const firstName = admin.firstName || admin.name?.split(' ')[0] || '';
  const lastName = admin.lastName || admin.name?.split(' ').slice(1).join(' ') || '';
  const displayName = admin.name || admin.firstName || '';

  return (
    <Wrapper $disabled={disabled}>
      <AvatarWrap>
        <Avatar
          firstName={firstName}
          lastName={lastName}
          image={admin.image || admin.avatarUrl}
          size="xs"
          tooltip={compact}
        />
      </AvatarWrap>
      {!compact && <AssigneeName $truncate={truncate}>{displayName}</AssigneeName>}
    </Wrapper>
  );
};

export default AssigneeDisplay;
